import { useId, type ReactElement, type ReactNode, cloneElement } from 'react';
import { cn } from '@/lib/utils';

type FieldProps = {
  label: string;
  error?: string | undefined;
  hint?: ReactNode;
  className?: string;
  /** Um único controle (Input, Textarea, Select trigger). Recebe id e aria automaticamente. */
  children: ReactElement<{ id?: string; 'aria-invalid'?: boolean; 'aria-describedby'?: string }>;
};

export function Field({ label, error, hint, className, children }: FieldProps) {
  const id = useId();
  const msgId = `${id}-msg`;
  return (
    <div className={cn('flex flex-col gap-1.5', className)}>
      <label htmlFor={id} className="text-[13px] font-medium text-fg-muted">
        {label}
      </label>
      {cloneElement(children, {
        id,
        'aria-invalid': error ? true : undefined,
        'aria-describedby': error || hint ? msgId : undefined,
      })}
      {error ? (
        <p id={msgId} className="text-[12.5px] text-danger animate-in">
          {error}
        </p>
      ) : hint ? (
        <p id={msgId} className="text-[12.5px] text-fg-subtle">
          {hint}
        </p>
      ) : null}
    </div>
  );
}
